import ActionStatus from '@sunbit-dev/common/enums/ActionStatus';
import IApplicationError from '@sunbit-dev/common/models/IApplicationError';
import { Actions, ActionTypes, LoadApplicationDocumentSuccess } from '../actions/applicationDocumentsActions';
import IDocument from '@sunbit-dev/common/models/IDocument';
import { DocumentTypesTypes } from '@sunbit-dev/common/enums/DocumentTypes';

export interface IApplicationDocumentsState { //extends Partial<IDocument> {
  type?: ActionTypes;
  status?: ActionStatus;
  error?: IApplicationError;
  documentType?: DocumentTypesTypes;
  documents: {
    [key in DocumentTypesTypes]?: IDocument;
  }
}

const initialState: IApplicationDocumentsState = {
  documents: {
  }
}

function isSuccessLoadApplicationDocument(action: unknown): action is LoadApplicationDocumentSuccess {
  return (action as Actions).status === ActionStatus.Success && Boolean((action as LoadApplicationDocumentSuccess).document);
}

export default function applicationDocumentReducer(state = initialState, action: Actions): IApplicationDocumentsState {
  switch(action.type) {
    case ActionTypes.LoadApplicationDocument:
      if (isSuccessLoadApplicationDocument(action)) {
        const {document, documentType, ...rest} = action;
        const documents = {...state.documents, [documentType]: document}
        return {...state, ...rest, documentType, documents};
      }
      return {...state, ...action};
    default:
      return state;
  }
}
